import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Image from "../atoms/Image";

interface FooterProps {
  logoSrc?: string;
  className?: string;
}

const Footer: React.FC<FooterProps> = ({
  logoSrc = "/logos/horizontal/sv-h-white.png",
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <footer className={`bg-gray-900 text-white py-12 px-6 ${className}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <Image
            src={logoSrc}
            alt="Surevision"
            className="h-8 mb-4"
            width="160"
            height="32"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <p className="text-gray-400 text-sm">{t("layout.footer.description")}</p>
        </div>

        <div>
          <h3 className="font-bold mb-4">{t("layout.company")}</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li>
              <Link to="/" className="hover:text-white transition-colors">
                {t("layout.home")}
              </Link>
            </li>
            <li>
              <Link to="/team" className="hover:text-white transition-colors">
                {t("layout.team")}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">{t("layout.legal")}</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li>
              <a href="#" className="hover:text-white transition-colors">
                {t("layout.privacy")}
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition-colors">
                {t("layout.terms")}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">{t("layout.contact")}</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li>info@surevisiontech.com</li>
            <li>+34 915 616 800 (Ext: 442332)</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
        <p>&copy; 2025 Surevision. {t("layout.footer.rights")}</p>
      </div>
    </footer>
  );
};

export default Footer;
